import BGMusicPlayer from './BGMusicPlayer';
export default BGMusicPlayer;